module.exports = __webpack_public_path__ + "img/mp.b59ef55c.svg";